var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as App from '../../app';
import { BlueButton, OrangeButton, EffectsContainer } from '../../lib/components';
import { t, r, PHRASES } from '../../translate';
import { plural } from '../../lib/utils';
import { getIndexes } from './getDailyBonusHistory';
import { CustomModal } from '../CustomModal';
import { getDayNumber } from '../../lib/utils/datetime/getDayNumber';
import { CoinsEffect } from '../../lib/classes/animation';
import './DailyBonusModal.less';
var BONUS_STEP = 100;
var DailyBonusModal = /** @class */ (function (_super) {
    __extends(DailyBonusModal, _super);
    function DailyBonusModal(props) {
        var _this = _super.call(this, props, 'DailyBonusModal Modal_flex Modal_blue') || this;
        _this.name = 'DailyBonusModal';
        _this.deltaBodyHeight = 200;
        _this.maxBodyHeight = 400;
        _this.currentDate = new Date();
        _this.indexes = getIndexes(_this.currentDate);
        _this.onGetBonus = function () { return __awaiter(_this, void 0, void 0, function () {
            var dayNumber, availableIndex, bonus;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.countAvailableBonusDays() > 0)) return [3 /*break*/, 3];
                        dayNumber = getDayNumber(this.currentDate);
                        availableIndex = this.indexes[0];
                        bonus = this.getBonusSize();
                        App.storage.upd({ dailyBonusReceivedDay: dayNumber });
                        if (availableIndex === 7) {
                            App.storage.upd({ dailyBonusHistory: [] });
                        }
                        if (!bonus) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.runCoins(bonus)];
                    case 1:
                        _a.sent();
                        this.props.onGetCoins(bonus);
                        _a.label = 2;
                    case 2:
                        this.indexes = getIndexes(this.currentDate);
                        this.draw();
                        DEVELOPMENT && console.log({ dayNumber: dayNumber, bonus: bonus });
                        App.sounds.clickButton();
                        return [3 /*break*/, 4];
                    case 3:
                        this.close();
                        App.sounds.click();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        if (DEVELOPMENT) {
            // @ts-ignore
            window['addBonusDay'] = function (days) {
                if (days === void 0) { days = 1; }
                var msInOneDay = 24 * 60 * 60 * 1000;
                _this.currentDate = new Date(_this.currentDate.getTime() + days * msInOneDay);
                _this.indexes = getIndexes(_this.currentDate);
                console.log('indexes', _this.indexes);
                _this.draw();
            };
            // @ts-ignore
            window['clearReceivedDayNumber'] = function () {
                App.storage.upd({ dailyBonusReceivedDay: 0 });
                _this.indexes = getIndexes(_this.currentDate);
                _this.draw();
            };
        }
        return _this;
    }
    DailyBonusModal.prototype.show = function () {
        this.update();
        _super.prototype.show.call(this);
    };
    DailyBonusModal.prototype.countAvailableBonusDays = function () {
        var _a = this.indexes, availableIndex = _a[0], receivedIndex = _a[1];
        return availableIndex - Math.max(0, receivedIndex);
    };
    DailyBonusModal.prototype.update = function () {
        var date = new Date();
        if (this.currentDate.toLocaleDateString() !== date.toLocaleDateString()) {
            this.currentDate = date;
            this.indexes = getIndexes(this.currentDate);
            this.draw();
        }
    };
    DailyBonusModal.prototype.getContent = function () {
        var _this = this;
        var countDays = this.countAvailableBonusDays();
        // prettier-ignore
        return [
            this.header(t(PHRASES.DailyBonus)),
            (this.body = this.DIV('scrollbar', [
                this.DIV('&__list', Array.from({ length: 7 }).map(function (_, index) {
                    var _a = _this.indexes, availableIndex = _a[0], receivedIndex = _a[1];
                    var day = String(index + 1);
                    var size = String((index + 1) * BONUS_STEP);
                    var className = 'Bonus-w';
                    if (index < availableIndex)
                        className += ' Bonus-w_available';
                    if (index < receivedIndex)
                        className += ' Bonus-w_received';
                    return _this.DIV({ className: className }, [_this.DIV({ className: 'Bonus', attrs: { 'data-day': day, 'data-size': size } })]);
                })),
                this.DIV('&__message', [this.getMessage()]),
                this.DIV('&__buttons-w', [
                    (this.button = new (countDays > 0 ? OrangeButton : BlueButton)({ onClick: this.onGetBonus }, [
                        t(countDays > 0 ? PHRASES.Take : PHRASES.Close)
                    ]))
                ])
            ]))
        ];
    };
    DailyBonusModal.prototype.getMessage = function () {
        var countDays = this.countAvailableBonusDays();
        if (countDays > 0) {
            // @ts-ignore
            return r(t(PHRASES.You_have_access_to_bonus_for_x_days), [plural(countDays, t(PHRASES.DaysPlural).split('|'))]);
        }
        return t(PHRASES.Come_back);
    };
    DailyBonusModal.prototype.getBonusSize = function () {
        var bonus = 0;
        var _a = this.indexes, availableIndex = _a[0], receivedIndex = _a[1];
        for (var i = Math.max(0, receivedIndex); i < availableIndex; i++) {
            bonus += (i + 1) * BONUS_STEP;
            DEVELOPMENT && console.log((i + 1) * BONUS_STEP);
        }
        return bonus;
    };
    DailyBonusModal.prototype.runCoins = function (coins) {
        return new Promise(function (resolve) {
            var x = window.innerWidth / 2;
            var y = Math.min(350, window.innerHeight / 2);
            var x2 = x;
            var y2 = 30;
            new EffectsContainer({
                effects: {
                    coins: new CoinsEffect({ coins: coins, x: x, y: y, x2: x2, y2: y2 }),
                },
                onDone: resolve,
            });
        });
    };
    return DailyBonusModal;
}(CustomModal));
export { DailyBonusModal };
